import { css } from 'styled-components';

export const bodyText = css`
  color: ${({ theme }) => theme.palette.white};
  font-family: ${({ theme }) => theme.fontFamily.body};
  font-size: ${({ theme }) => theme.fontScale.S};
  line-height: var(--bc-lineHeights-base);
`;
